import { Capacitor } from "@capacitor/core";
import { useNavigate } from "react-router-dom";
import { clearAppRole } from "../lib/appRole";
import React from "react";
import BrowseBody from "../components/BrowseBody";
import "./FanHomePage.css";
import { T } from "../i18n/T";

// App fan mode — Browse tab (locked r6 §5, founder polish): the
// full-width search bar with the Industry Leaders carousel beneath it —
// same interactive carousel as the landing page, every card opens that
// talent's request page — and the fan's "Saved" row under it (1.5.3). The
// content is components/BrowseBody, shared with the talent's Discover sheet.
// The header chip (Layout's Header on customer pages) is the profile entry.
//
// The Browse "Log out" line is GONE (founder round 2): the app's
// door out of fan mode now lives on the My Profile editor's Sign out,
// which on native also clears the role and returns to the welcome tour.

const FanHomePage: React.FC = () => {
  const navigate = useNavigate();
  return (
  // The tab owns its scroll (the last uncovered fan tab; twin of
  // FanRequestsPage/FanLeaderboardPage): the document never scrolls, so
  // iOS overscroll can't drag the fixed header / tab bar. Browse only
  // outgrows one screen when search results or the trending feed run long
  // — exactly when the old min-height page started document-scrolling.
  <div className="fanhome-scroll">
    <div className="fanhome">
      <BrowseBody />
      {/* Faint R in the empty space beneath the carousel (founder decision) —
          same treatment as the DJ Pending void. */}
      <div className="fanhome-void" aria-hidden="true">
        <img src="/r.png" alt="" className="fanhome-void-r" />
      </div>
      {/* The way out of fan mode (1.4.1, founder): one visible row, no
          digging through the sign-in sheet. App only — web fans have no
          role to leave. Forgets the pick and reopens the role screen. */}
      {Capacitor.isNativePlatform() && (
        <button
          type="button"
          className="fanhome-switch"
          onClick={() => {
            clearAppRole();
            navigate("/welcome?role=1");
          }}
        >
          <T k="fanHomePage.areYouADj" tags={{ 0: (c) => <b>{c}</b>, 1: (c) => <span aria-hidden="true">{c}</span> }} />
        </button>
      )}
    </div>
  </div>
);
};

export default FanHomePage;
